import { Component } from '@angular/core';

import { gpActions } from '../const/gp-actions.const';
import { gpPersonas } from '../const/gp-personas.const';
import { TranslationKeyMap } from '../gp-main.i18n';

@Component({
    selector: 'cmps-gp-legend-dialog',
    templateUrl: './gp-legend-dialog.component.html',
})
export class GpLegendDialogComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _gpPersonas = Array.from(gpPersonas.values());

    /** @private */
    _gpActions = Array.from(gpActions.values());
}
